"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    fit: {
      type: String,
      default: 'contain'
    },
    show: {
      type: Boolean,
      default: false
    },
    file: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    defaultImage: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    files: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      initialIndex: 0
    };
  },
  watch: {
    show: {
      handler: function handler(nv) {
        var _this = this;
        if (nv) {
          var _this$files$map$find;
          var file = this.defaultImage;
          var ref = this.$refs['el-carousel'];
          var name = this.imageName(file);
          this.initialIndex = (_this$files$map$find = this.files.map(function (f, i) {
            return _this.imageName(f) === name ? i : null;
          }).find(function (f) {
            return _this.$$isNoEmpty(f);
          })) !== null && _this$files$map$find !== void 0 ? _this$files$map$find : 0;
          ref.setActiveItem(name);
        }
      },
      deep: true
    }
  },
  methods: {
    imageName: function imageName(file) {
      var _ref, _file$id;
      return '' + ((_ref = (_file$id = file.id) !== null && _file$id !== void 0 ? _file$id : file.uid) !== null && _ref !== void 0 ? _ref : file.url);
    }
  }
};